import React from 'react'
import LearningContinuumInfo from './LearningContinuumInfo'
import Fields from '../../Fields/Fields'

const LearningContinuumFields = ({ changes, detail }) => {
  if (changes.fields.includes('notes')) {
    return (
      <>
        <LearningContinuumInfo
          detail={{
            lcElements: detail.lcElements,
            curriculumElements: detail.curriculumElements
          }} 
          showCurriculumName={false}
        />
        <Fields changes={changes} />
      </>
    )
  }

  const getObject = (fields = []) => {
    let oldValues = {};
    let newValues = {};
    fields.forEach((field) => {
      oldValues[field] = 'Details preview'
      newValues[field] = 'Details preview'
    })
    
    return {
      fields,
      oldValues,
      newValues
    }
  }

  return (
    <>
      <LearningContinuumInfo 
        detail={detail}
        oldValues={changes.oldValues}
        showCurriculumName={false}
      />
      <Fields 
        changes={getObject(changes.fields)} 
      />
    </>
  )
}

export default LearningContinuumFields